<template>
    <div class="dash-title">{{titulo}}</div>
</template>

<script>
    export default {
        name: 'MinhasLicitacoesTituloSecao',
        props: {
            titulo: {
                required: true,
                type: String
            }
        }
    }
</script>

<style lang="stylus">
    .dash-title
        padding: 10px 40px 0
        color: #3a6861
        font-weight: bold
        font-size: 16px
</style>